import { Modal, ModalProps } from 'ui';

import { BankAccountForm } from '../../forms/BankAccountForm/BankAccountForm';

interface BankAccountModalProps extends ModalProps {
  modalProps?: Partial<ModalProps>;
}

const BankAccountModal = ({ opened, onClose, modalProps, title }: BankAccountModalProps) => {
  return (
    <Modal opened={opened} onClose={onClose} title={title ?? 'Connect My Bank'} {...modalProps}>
      <BankAccountForm onClose={onClose} />
    </Modal>
  );
};

export { BankAccountModal };
